import { Builder } from '@builder.io/react';
import React, { useState } from 'react';
import HtmlContent from '../../../../general/htmlContent';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const AccordionWidget = props => {
  const { question, answer, tag = 'div', questionStyle = '', answerStyle = '', containerStyle = '' } = props;

  const [activeIndex, setActiveIndex] = useState(false);

  return (
    <div className={`bg-white rounded-md w-full shadow-md p-4 flex flex-col justify-center items-center text-[#78716C] ${containerStyle}`}>
      <div onClick={() => setActiveIndex(!activeIndex)} className="flex w-full justify-between rounded px-4 py-2 cursor-pointer">
        {React.createElement(tag, {
          className: `font-montserratBold text-xl transition-all duration-300 ${activeIndex ? 'text-[#00a3da]' : 'text-[#777]'} ${questionStyle}`,
          dangerouslySetInnerHTML: { __html: question },
        })}
        <div className="flex items-center justify-center">
          <ChevronDownIcon className={`w-4 h-4 text-stone-600 transition-all duration-300 ${activeIndex ? 'rotate-180' : ''}`} />
        </div>
      </div>

      <div
        className={`shadow-3xl w-full rounded-md shadow-cyan-500/50 bg-stone-50 transition-all duration-200 ease-in-out px-3 sm:px-6 font-montserratMedium ${
          activeIndex ? 'py-4 mb-6' : 'h-0 overflow-hidden'
        }  ${answerStyle}`}
      >
        <HtmlContent htmlCode={answer} />
      </div>
    </div>
  );
};

Builder.registerComponent(AccordionWidget, {
  name: 'AccordionWidget',
  inputs: [
    {
      name: 'question',
      type: 'longText',
      friendlyName: 'Question (HTML or Text)',
      helperText: 'Supports raw HTML too',
    },
    {
      name: 'tag',
      type: 'string',
      friendlyName: 'HTML Tag for Question',
      defaultValue: 'div',
      enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'div'],
      helperText: 'Choose how the question should be rendered (e.g. h1, h2, p, etc.)',
    },
    {
      name: 'answer',
      type: 'longText',
      friendlyName: 'Answer (HTML supported)',
      helperText: 'Supports <p>, <ul>, <strong> etc.',
    },
    {
      name: 'containerStyle',
      type: 'string',
      friendlyName: 'Tailwind Classes for Main Container',
      helperText: 'Optional: Add Tailwind CSS classes to the main container',
    },
    {
      name: 'questionStyle',
      type: 'string',
      friendlyName: 'Tailwind Classes for Question',
      helperText: 'Optional: Add Tailwind CSS classes to the question text element',
    },
    {
      name: 'answerStyle',
      type: 'string',
      friendlyName: 'Tailwind Classes for Answer Box',
      helperText: 'Optional: Add Tailwind CSS classes to style the answer container',
    },
  ],
});

export default AccordionWidget;
